module.exports = __webpack_public_path__ + "static/media/snake-small.eac32835.gif";